<template>
    <vs-popup classContent="popup-example"  title="ویرایش فاکتور" :active.sync="showPopup">
        <div class="mb-base">
            <div class="center">
                <form class="p-4" @keydown.enter="editFactorInfo()">
                    <vs-row class="px-5 my-4">
                        <vs-col vs-w="3" class="px-2">
                            <label class="vs-input--label">عنوان</label>
                            <vs-input class="w-full" v-model="factor.title" />
                        </vs-col>
                        <vs-col vs-w="6" class="px-2">
                            <label class="vs-input--label">روش پرداخت</label>
                            <v-select :options="paymentMethod" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="factor.type" :clearable="false" />
                        </vs-col>
                        <vs-col vs-w="3" class="px-2">
                            <label class="vs-input--label">وضعیت</label>
                            <v-select :options="statusList" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="factor.status" :clearable="false" />
                        </vs-col>
                    </vs-row>

                    <div class="vx-row px-5 my-4">
                        <div class="vx-col w-full">
                            <label class="vs-input--label">توضیحات</label>
                            <vs-textarea v-model="factor.text" class="mt-4" />
                        </div>
                    </div>

                    <vs-divider class="mb-5" />
                    <vs-row vs-w="12" class="px-5">
                        <vs-col vs-w="2" class="px-2"></vs-col>
                        <vs-col vs-w="3" class="px-2">
                            <label class="vs-input--label">عنوان</label>
                        </vs-col>
                        <vs-col vs-w="2" class="px-2">
                            <label class="w-full vs-input--label">تعداد</label>
                        </vs-col>
                        <vs-col vs-w="2" class="px-2">
                            <label class="w-full vs-input--label">فی</label>
                        </vs-col>
                        <vs-col vs-w="2" class="px-2">
                            <label class="w-full vs-input--label">قیمت</label>
                        </vs-col>
                        <vs-col vs-w="1" class="px-2"></vs-col>
                        
                    </vs-row>

                    <draggable
                        :list="details"
                        tag="ul"
                        class="list-group list-group-flush"
                        handle=".handle"
                    >
                        <div v-for="(item, index) in details" :key="index" class="py-1">
                            <vs-row vs-w="12" class="px-5">
                                <vs-col vs-w="2" class="px-2">
                                    <vs-button class="mr-3 float-right btn-icon" color="danger" type="flat" @click="removeRow(index)" v-if="details.length > 1">
                                        <feather-icon icon="XIcon" />
                                    </vs-button>
                                    <feather-icon icon="AlignRightIcon" class="handle cursor-move" />
                                </vs-col>
                                <vs-col vs-w="3" class="px-2" v-if="item.title == 'مالیات بر ارزش افزوده' ">
                                    <vs-input class="w-full" readonly v-model="item.title" />
                                </vs-col>
                                <vs-col vs-w="3" class="px-2" v-else>
                                    <vs-input class="w-full" v-model="item.title" />
                                </vs-col>
                                <vs-col vs-w="2" class="px-2">
                                    <vs-input class="w-full input-center" v-model="item.quantity" @change="totalPrice(item.quantity, item.price, index)" />
                                </vs-col>
                                <vs-col vs-w="2" class="px-2">
                                    <vs-input class="w-full input-center" v-model="item.price" @change="totalPrice(item.quantity, item.price, index)" />
                                </vs-col>
                                <vs-col vs-w="2" class="px-2">
                                    <vs-input class="w-full input-center" readonly v-model="item.total_price" />
                                </vs-col>
                                <vs-col vs-w="1" class="px-2" style="margin-top:-16px;">
                                    <label v-if="item.type">هزینه</label>
                                    <label v-else>تخفیف</label>
                                    <vs-switch v-model="item.type" icon-pack="feather" vs-icon-off="icon-arrow-down" vs-icon-on="icon-arrow-up" class="mt-1" />
                                </vs-col>
                                
                            </vs-row>                          
                        </div>
                    </draggable>

                    <vs-divider class="mb-5" />
                    <div class="vx-row px-5 my-4">
                        <div class="vx-col w-1/3"> پیش پرداخت </div>
                        <div class="vx-col w-1/3"> {{factor.fields.prepayment.price}} </div>
                    </div>
                    <div class="vx-row px-5 my-4">
                        <div class="vx-col w-1/3"> بعد از تحویل </div>
                        <div class="vx-col w-1/3"> {{factor.fields.afterDelivery.price}} </div>
                    </div>
                    <div class="vx-row px-5 my-4">
                        <div class="vx-col w-1/3"> بعد از نصب </div>
                        <div class="vx-col w-1/3"> {{factor.fields.afterInstallation.price}} </div>
                    </div>
                    <div class="vx-row px-5 my-4">
                        <div class="vx-col w-1/3"> مجموع </div>
                        <div class="vx-col w-1/3"> {{factor.fields.price_sum}} </div>
                    </div>

                    
                    
                    <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                        <vs-col class="sm:w-1/2 w-full">
                            
                        </vs-col>
                        <vs-col class="sm:w-1/2 w-full">
                            <vs-button class="mr-3 float-right" @click="editFactorInfo()">ثبت</vs-button>
                            <vs-button class="mr-3 float-right" type="border" @click="addForm()">افزودن</vs-button>
                        </vs-col>
                    </vs-row>
                </form>
            </div>
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'
import draggable from 'vuedraggable'

// For custom error message
import { Validator } from 'vee-validate';
const dict = {
    custom: {
        title: {
            required: 'اجباری*',
        },
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    name: 'EditFactor',

    props: {
        popupEditFactor: {
            type: Boolean,
            default: false,
        },
        factorId: Number
    },

    components: {
        // Intersect,
        vSelect,
        draggable
    },
    
    data() {
		return{
            showPopup: false,
            
            factor: {},

            details: [],

            statusList: [
                {
                    label: 'پرداخت نشده',
                    value: 'unpaid'
                },
                {
                    label: 'پرداخت شده',
                    value: 'paid'
                },
                {
                    label: 'کنسل شده',
                    value: 'canceled'
                },
            ],
            
            paymentMethod: [
				{
					label: '70% پیش پرداخت و 30 % هنگام تحویل محصول',
					value: 'prepayment',
				},
				{
					label: '50% پیش پرداخت و 50% هنگام تحویل محصول',
					value: 'afterDelivery',
				},
				{
					label: '50% پیش پرداخت و 50% پس از نصب محصول',
					value: 'afterInstallation',
				},
				{
					label: '100% پس از نصب محصول',
					value: 'manual',
				},
                {
					label: 'فاکتور اختصاصی',
					value: 'custom',
				},
            ],
            
		}
    },
    
    computed: {
    },

    watch: { 
      	popupEditFactor: function(newVal) {
            this.showPopup = newVal
            if(newVal == true){
                this.$vs.loading()
                this.$store.dispatch('getFactorInfo', this.factorId)
                .then(res => {
                    this.$vs.loading.close()
                    this.factor = res.data[0]
                    this.details = res.data[0].fields.data.fields
                    this.details.forEach(item => {
                        if(item.type == 'increase') {
                            item.type = true
                        }
                        else {
                            item.type = false
                        }
                    });
                    this.paymentMethod.forEach(item => {
                        if(item.value == this.factor.type) {
                            this.factor.type = item.label
                        }
                    });
                    this.statusList.forEach(item => {
                        if(item.value == this.factor.status) {
                            this.factor.status = item.label
                        }
                    });
                })
                .catch(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        title: '',
                        text: 'خطا در دریافت اطلاعات',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'warning'
                    })
                })
            }
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupEditFactor', newVal)
        },
    },

    created(){	
    },
    
    methods: {
        updateItemQuantity(event, n) {
            this.orders[n].quantity = event
        },

        removeRow(i){
            if (i > -1) {
                this.details.splice(i, 1);
            }
        },

        addForm() {
            let item = {
                title: '',
                price: 0,
                total_price: 0,
                type: true,
                quantity: 1,
            }
            this.details.push(item)
        },

        totalPrice(quantity, price, index){
            this.details[index].total_price = quantity * price
        },

        editFactorInfo(){
            this.$vs.loading()
            this.$emit('updatePopupEditFactor', false)
            this.details.forEach(item => {
                if(item.type == true) {
                    item.type = 'increase'
                }
                else {
                    item.type = 'decrease'
                }
                item.price = parseInt(item.price)
            });
            let status = ''
            if(this.factor.status.value){
                status = this.factor.status.value
            }
            else {
                this.statusList.forEach(element => {
                    if(element.label == this.factor.status){
                        status = element.value
                    }
                });
            }
            let type = ''
            if(this.factor.type.value){
                type = this.factor.type.value
            }
            else {
                this.paymentMethod.forEach(element => {
                    if(element.label == this.factor.type){
                        type = element.value
                    }
                });
            }

            const itemIndex = this.details.findIndex(item => item.title === 'مالیات بر ارزش افزوده');
            if(itemIndex  != -1){
                this.details.splice(itemIndex , 1);
            }

            let payload = {
                order_id: parseInt(this.factor.order_id),
                title: this.factor.title,
                type: type,
                status: status,
                pay_time: this.factor.pay_time,
                fields: this.details,
                id: this.factorId
            }
			this.$store.dispatch('updateFactorInfo', payload)
			.then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'فاکتور با موفقیت ویرایش شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'اطلاعات وارد شده صحیح نمی باشد.',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        },
    }
}
</script>

<style scope>
.con-vs-popup .vs-popup {
    width: 80% !important;
}

.input-center input[type = 'text'] {
    text-align: center !important;
}

.handle {
  padding-top: 8px;
}
</style>